
export default {
  /* Global Vocabulary */

  back: "Back",
  cancel: "Cancel",
  email: "Email",
  mobile: "Mobile",
  country_of_residence: 'Country of residence',
  i_did_not_register_yet: "Create New Account",
  i_forgot_my_password: "Forgot your password?",
  login: "Login",
  logout: "Logout",
  password: "Password",
  password_confirmation: "Password Confirmation",
  confirm: "Confirm",
  save: "Save",
  unspecified_error: "Unspecified error! Please report to the webmaster!",
  username: "Username",
  i_already_have_an_account: "I already have an account",
  create_new_rebit_account: "Create new Rebit account",
  please_enter_your_email: "Please enter your email",
  country_is_required :"Country is required!",
  password_criteria: "Password must contain a <b>letter</b> and a <b>number</b>, and be minimum of<b>8 characters</b>",
  terms_and_conditions: "Terms and Conditions",
  privacy_policy: "Privacy Policy",
  terms: "By registering, you accept Rebit's {terms_and_conditions} and {policy} and allow Rebit to contact you and send you marketing communications using the contact details you have provided to us.",

  auth: {
    activation: "Activation",
    activation_code_not_approved: "Activation code not approved",
    activation_code_sent: "A 6-digit code was sent to {email}.",
    activation_code_sent_notify: "An email containing the activation code has been sent to you.",
    confirm_activation_code: "Confirm activation code",
    email_hint: "Only gmail service is acceptable",
    enter_the_code_here: "Enter the code here",
    error_in_registration_operation: "The registration operation on the server resulted in an error.",
    i_entered_the_email_incorrectly: "I entered the email incorrectly",
    no_email_received_resend: "No email received, resend",
    referral_code: "Reward code (Optional)",
    referral_code_hint: "If someone introduced Rebit to you, insert their 6 digit code here and you'll both get a reward.",
    sign_up: "Create new account",
    successful_register_message: "Your registration was successful. Log in with your username and password.",
    user_info: "User Credentials",
    login_to_your_rebit_account: "Login to your Rebit account",
      out_of_date_rebit_app: "Out-of-date Rebit app",
    you_are_successfully_registered: "You are successfully registered!",
    i_forgot_my_password: "I forgot my password",
    i_know_the_password_go_to_login: "I know the password, go to Login",
    not_sure_create_a_new_account: "Not sure, create a new account",
    select_your_country_of_residence: 'Select your country of residence',
    errors: {
      poor_connection_refresh_and_try_again: "Poor_connection. Refresh and try again!",
      email_already_taken: "Email already taken!",
      invalid_recaptcha: "Invalid reCAPTCHA!",
      it_may_be_due_to_your_internet_speed: "It may be due to your internet speed. Please try again!",
      check_your_email_and_use_the_verification_code: "Check your email and use the verification code",
      you_or_someone_else_has_created_an_unverified_account_with_this_email_already: "You or someone else has created an unverified account with this email already. What do you want to do?"
    },
  },

  forgot: {
    get_activation_code: "Request activation code",
    hint: "Let us know the email you use to login to Rebit and we’ll help you choose a new password.",
    errors: {
      invalid_email_address: "Invalid email address",
      invalid_password: "Invalid Password"
    },
  },

  verify: {
    index: "Verify",
    a_verification_code_sent_to_your_email: "A verification code sent to your email.",
    please_enter_it_here: "Please enter it here",
    i_didnt_get_any_email_send_it_again: "I didn't get any email, send it again",
    change_password: "Change Password",
    invalid_password: "Invalid password!",
    current_password: "Current Password",
    new_password: "New Password",
    new_password_confirmation: "New Password Confirmation",
    password_confirmation_does_not_match: "Password confirmation does not match.",
    password_has_been_changed_successfully: "Password has been changed successfully!",
    your_password_has_been_changed_successfully: "Your password has been changed successfully!",
    you_should_logout_to_apply: "You should logout to apply!",
    there_is_an_error_when_sending_email : "There is an error when sending email.",
    please_refresh_the_page_and_try_again: "Please refresh the page and try again."
  }
}
